import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSubscription } from "../redux/authSlice";
import { api1 } from "../utils/axiosInstance";
import SubscriptionModal from "./SubscriptionModal";
import SecondaryLoader from "./SecondaryLoader/SecondaryLoader";

const SubscriptionGuard = ({ children, allowedPlans = [] }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { subscription } = useSelector((state) => state.auth);
  const token = useSelector((state) => state.auth.token);
  const [showModal, setShowModal] = useState(false);
  const [blockAccess, setBlockAccess] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkSubscription = async () => {
      if (subscription && subscription.plan) {
        if (!allowedPlans.includes(subscription.plan)) {
          setShowModal(true);
          setBlockAccess(true);
        }
        setChecking(false);
        return;
      }

      try {
        const response = await api1.get(
          "/api/subscription/get-subscription-plan"
        );
        dispatch(setSubscription(response.data));
        if (!allowedPlans.includes(response.data.plan)) {
          setShowModal(true);
          setBlockAccess(true);
        }
      } catch (error) {
        console.error("Subscription check failed", error);
        setShowModal(true);
        setBlockAccess(true);
      } finally {
        setChecking(false);
      }
    };

    checkSubscription();
  }, [allowedPlans, token, dispatch, subscription]);

  const handleClose = () => {
    setShowModal(false);
    navigate("/dashboard/home");
  };

  const handleUpgrade = () => {
    setShowModal(false);
    setBlockAccess(false);
    navigate("/dashboard/help-and-support/update-subscription");
  };

  if (checking) return <SecondaryLoader />;

  if (blockAccess && showModal) {
    return (
      <SubscriptionModal
        currentPlan={subscription.plan}
        onClose={handleClose}
        onUpgrade={handleUpgrade}
      />
    );
  }

  return children;
};

export default SubscriptionGuard;
